import React from 'react';

import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages';

import { MakeLongerIcon } from '../../../../icons/prompt/makeLonger';
import { createInsertBelow, createReplace } from '../../actions/create-actions';
import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
import type {
	EditorPluginAIConfigItemWithOptions,
	EditorPluginAIConfigItem,
} from '../../config-items';

const intentSchemaId = 'make_longer.json';

export const makeLonger: EditorPluginAIConfigItem = {
	key: CONFIG_ITEM_KEYS.MAKE_LONGER,
	title: aiConfigItemMessages.makeLongerTitle,
	description: aiConfigItemMessages.makeLongerDescription,
	icon: () => <MakeLongerIcon />,
	statusLozengeType: 'beta',
	intentSchemaId,
	getBackendModel: () => 'assistance-service',
	showInRefineDropdown: true,
	actions: {
		empty: [
			createInsertBelow({ appearance: 'secondary' }),
			createReplace({ appearance: 'primary' }),
		],
		selection: [
			createInsertBelow({ appearance: 'secondary' }),
			createReplace({ appearance: 'primary' }),
		],
	},
};

export const makeLongerWithOptions: EditorPluginAIConfigItemWithOptions = {
	config: makeLonger,
	triggers: { empty: { enabled: true, docMinSize: 1 }, selection: { enabled: true } },
};
